import React, { Suspense, lazy } from 'react';
import { Hero } from '../components/Hero';
// Below-the-fold sections are loaded on demand so the initial JS bundle
// (and therefore FCP / LCP) only needs the Hero. This keeps the critical
// path small while the rest streams in as the user scrolls.
const PainPoints = lazy(() => import('../components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const Solution = lazy(() => import('../components/Solution').then(m => ({
  default: m.Solution
})));
const Benefits = lazy(() => import('../components/Benefits').then(m => ({
  default: m.Benefits
})));
const RecipeCategories = lazy(() => import('../components/RecipeCategories').then(m => ({
  default: m.RecipeCategories
})));
const Bonuses = lazy(() => import('../components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Pricing = lazy(() => import('../components/Pricing').then(m => ({
  default: m.Pricing
})));
const Guarantee = lazy(() => import('../components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const HowItWorks = lazy(() => import('../components/HowItWorks').then(m => ({
  default: m.HowItWorks
})));
const Testimonials = lazy(() => import('../components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const FAQ = lazy(() => import('../components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('../components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
export function LandingPage() {
  return <main className="min-h-screen bg-brand-bg font-sans selection:bg-brand-accent/30" data-id="element-217">
      <Hero data-id="element-218" />

      <Suspense fallback={<div className="min-h-[40vh]" aria-hidden="true" data-id="element-220" />} data-id="element-219">
        <PainPoints data-id="element-221" />
        <Solution data-id="element-222" />
        <Benefits data-id="element-223" />
        <RecipeCategories data-id="element-224" />
        <Bonuses data-id="element-225" />
        <Pricing data-id="element-226" />
        <Guarantee data-id="element-227" />
        <HowItWorks data-id="element-228" />
        <Testimonials data-id="element-229" />
        <FAQ data-id="element-230" />
        <FinalCTA data-id="element-231" />
      </Suspense>

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-232">
        <div className="max-w-6xl mx-auto px-4" data-id="element-233">
          <p className="mb-2" data-id="element-234">
            © {new Date().getFullYear()} NoveliaHub. Todos los derechos
            reservados.
          </p>
          <p className="text-xs max-w-3xl mx-auto mt-4 text-gray-500" data-id="element-235">
            Descargo de responsabilidad: La información contenida en este sitio
            web y en el recetario tiene fines educativos e informativos
            únicamente y no sustituye el consejo, diagnóstico o tratamiento
            médico profesional. Siempre busque el consejo de su médico u otro
            proveedor de salud calificado con cualquier pregunta que pueda tener
            sobre una condición médica.
          </p>
        </div>
      </footer>
    </main>;
}